import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
//import { useFetch } from '../../hooks/useFetch'
import { projectFirestore } from '../../firebase/config'
import { useNavigate } from 'react-router-dom'
import Stars from '../../components/Stars'

// styles
import './Recipe.css'

export default function Recipe() {
  const { id } = useParams()
  //const url = 'http://localhost:3000/recipes/' + id
  //const { error, isPending, data: recipe } = useFetch(url)
  const [rating, setRating] = useState(null)

  const [isPending, setIsPending] = useState(false)
  const [error, setError] = useState(null)
  const [recipe, setRecipe] = useState(null)
  const navigate = useNavigate()

  //const [rating1, setRating1] = useState(null)
  let rating1 = 0
  let rating2 = 0
  let rating3 = 0
  let rating4 = 0

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("stars:", recipe.stars)
    console.log("reviews:", recipe.reviews)
    console.log("rating:", rating)
    if (rating) {
      rating1 = recipe.stars * recipe.reviews + Number(rating)
      //rating2 = rating1 + Number(rating)
      rating2 = recipe.reviews + 1
      rating3 = rating1 / rating2
      //rating4 = Math.round(rating3)
      rating4 = Number(rating3.toFixed(1))
      //rating4 = rating3
    }
    console.log("rating1-4:", rating1, rating2, rating3, rating4)

    //update rating & reviews here.f recipe doc
    {
      rating2 &&
        projectFirestore.collection('polhokdb').doc(id).update({
          stars: rating4, reviews: rating2
        })
    }
    navigate('/')  //history.push('/')
  }

  useEffect(() => {
    setIsPending(true)

    projectFirestore.collection('polhokdb').doc(id).get().then(doc => {
      if (doc.exists) {
        setIsPending(false)
        setRecipe(doc.data())
      } else {
        setIsPending(false)
        setError(`Could not find that recipe`)
      }
    })

  }, [id])

  return (
    <div className="recipe">
      {/* <div>Recipe.js</div> */}
      {error && <p className="error">{error}</p>}
      {isPending && <p className="loading">Loading...</p>}
      {recipe && (
        <>
          <h2 className="page-title">Title: {recipe.title} -
            Author: {recipe.author} - Stars: {recipe.stars}
            <Stars no={recipe.stars} /> - 
            Reviews: {recipe.reviews} 
          </h2>
          <p className="method"><b>Joke: </b>{recipe.body}</p>
          {/* <b>Search Tags: </b> */}
          {/* {recipe.tags.map(ing => <span key={ing}>{ing}  </span>)} */}

          <br></br> 
          <form onSubmit={handleSubmit}>
            <label>
              <p></p> <p></p>
              <b>Rate the Joke: </b>
              <select className="sel" onChange={(e) => setRating(e.target.value)}>
                <option className="sel" value="">skip</option>
                <option className="sel" value="1">1 star</option>
                <option className="sel" value="2">2 stars</option>
                <option className="sel" value="3">3 stars</option>
                <option className="sel" value="4">4 stars</option>
                <option className="sel" value="5">5 stars</option>
              </select>
            </label>
            {/* <p>rating:{rating}</p> */}
            <button className="selBtn">Submit</button>
          </form>

        </>
      )}
    </div>
  )
}